import * as React from "react";
import { Services, Assets, Logger } from "@sendum/core";

import s from "./VisibilityReports.module.scss";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setMultiplePlaceComponent } from "../store/VisibilityActions";
import { VisibilityRootState } from "../store/VisibilityStore";
import { AnyAction } from "redux";

const TRIP_REPORT_TYPE = "21-cfr-part-11-summary-widget-report";

const logger = new Logger("VisibilityReports");

interface IVisibilityReportsState {
	trip: {
		loading: boolean;
		name?: string;
	};
	error?: Error;
}

const VisibilityReports = () => {
	const dispatch = useDispatch();
	const shipment = useSelector((state: VisibilityRootState) => state.Visibility.shipment, shallowEqual);
	const device = useSelector((state: VisibilityRootState) => state.Visibility.device, shallowEqual);


	const [state, setState] = React.useState<IVisibilityReportsState>({
		trip: {
			loading: false,
		},
	});

	React.useEffect(() => {
		if (state.trip.name) {
			waitTripReport();
		}
	}, [state.trip.name]);

	const onClickCloseHandler = (event: any) => {
		Boolean(event.preventDefault) && event.preventDefault();
		dispatch(setMultiplePlaceComponent("graph") as unknown as AnyAction);
	};

	const onClickTripReportHandler = (event: any) => {
		Boolean(event.preventDefault) && event.preventDefault();
		if (!state.trip.loading) {
			generateTripReport();
		}
	};

	const generateTripReport = () => {
		if (!shipment?.id || !device?.id) {
			setState({ ...state, ...{ error: new Error() } });

			return;
		}
		setState({ ...state, ...{ trip: { loading: true } } });

		Services.API.WidgetsApi.generateReport(shipment.id, device.id, TRIP_REPORT_TYPE)
		  .then((reportName: string) => {
		    setState({ ...state, ...{ trip: { loading: true, name: reportName } } });
		  })
		  .catch((err: any) => setState({ ...state, ...{ error: new Error(err) } }));
	};

	const waitTripReport = () => {
		const reportName = state.trip.name;
		if (reportName) {
			const interval = setInterval(() => {
				Services.API.WidgetsApi.getReport(reportName)
			    .then((url: string) => {
			      setState({ ...state, ...{ trip: { ...state.trip, ...{ loading: false } } } });
			      setTimeout(() => {
			        window.location.href = url;
			      }, 100);
			      clearInterval(interval);
			    })
			    .catch((err: any) => {
			      logger.error(err);
			      setState({ ...state, ...{ error: new Error() } });
			    });
			}, 5000);
		}
	};

	return (
		<div className={s.reports}>
			<div className={s.close}>
				<img alt={"close"} src={Assets.Close} onClick={onClickCloseHandler}/>
			</div>
			<div className={s.reports__column}>
				<div className={[s.reports__header, s.header].join(" ")}>
					<div className={s.header__row}>
						<div className={s.header__text}>
              Reports
						</div>
					</div>
				</div>
				<div className={[s.reports__list, s.list].join(" ")}>
					<div className={s.list__column}>
						<div className={[s.list__item, s.item].join(" ")}>
							<div className={s.item__row}
								onClick={onClickTripReportHandler}>
								<div className={[s.item__text, state.trip.loading ? s.item__text_loading : ""].join(" ")}>
                  Trip Report
								</div>
								<div className={[s.item__icon, state.trip.loading ? s.item__icon_loading : ""].join(" ")}>
									<img alt={"download/loading"} src={state.trip.loading ? Assets.Load : Assets.Download}/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default VisibilityReports;
